import { CURRENCIES, DEFAULT_CURRENCY } from '@weft/types';
import type { Currency } from '@weft/types';
import { isNullOrUndefined, raiseUnreachable } from '@weft/utils';
import { formatNumberWithPrecision } from '../../utils/number';

export function getFormattedNumberWithCurrencySymbol(currency: Currency, number: number, precision?: number): string {
  return `${formatNumberWithPrecision(number, precision ?? 2)}${getCurrencySymbol(currency)}`;
}

export function getCurrencySymbol(currency: Currency | undefined): string {
  return isNullOrUndefined(currency) ? getDefaultCurrencySymbol() : mapCurrencyToSymbol(currency);
}

export function getDefaultCurrencySymbol(): string {
  return mapCurrencyToSymbol(DEFAULT_CURRENCY);
}

function mapCurrencyToSymbol(currency: Currency): string {
  switch (currency) {
    case CURRENCIES.Eur:
      return '€';
    case CURRENCIES.Gbp:
      return '£';
    case CURRENCIES.Ils:
      return '₪';
    case CURRENCIES.Usd:
      return '$';
    default:
      return raiseUnreachable(currency);
  }
}